module.exports = __webpack_public_path__ + "img/fr.9bc99cb9.svg";